document.addEventListener("DOMContentLoaded", function () {
  // Resets class selector before new megamenu is opened
  async function removeExpandedClass() {
    // Get all elements with the class '.full-mega-menu--panel--level'
    var panels = document.querySelectorAll(
      ".full-mega-menu--panel--level .full-mega-menu--subpanel"
    );

    // Use Promise to handle asynchronous behavior
    return new Promise((resolve) => {
      // Counter to track the number of panels processed
      let count = 0;

      // Loop through each panel
      panels.forEach(function (panel) {
        // Check if the panel has the class 'is-expanded'
        if (panel.classList.contains("is-expanded")) {
          panel.classList.add("is-closing");
          panel.style.opacity = "0";
          setTimeout(() => {
            // Remove the 'is-expanded' class
            panel.classList.remove("is-expanded");
            panel.classList.remove("is-closing");
            count++;

            // If all panels have been processed, resolve the promise
            if (count === panels.length) {
              resolve(true);
            }
          }, 300);
        } else {
          count++;

          // If all panels have been processed, resolve the promise
          if (count === panels.length) {
            resolve(true);
          }
        }
      });
    });
  }

  const megaMenus = document.querySelectorAll(".full-mega-menu--menu-primary");
  const isPage = Array.from(megaMenus).some(
    (item) => item.getAttribute("data-path") === window.location.pathname
  );
  const isHomePage = document.body.classList.contains("template-index") || isPage;

  megaMenus.forEach(function (megaMenu) {
    const category = megaMenu.getAttribute("data-category"); // Gets Womens or Mens or secondary
    const primaryNavItems = megaMenu.querySelectorAll('li[role="menuitem"]');
    const categoryPanel = document.querySelector(`.full-mega-menu--panel-${category}`);
    let isExpanding = false; // Flag to track if menu is currently expanding
    // Find the parent element of the megaMenu
    const parentElement = megaMenu.closest(".full-mega-menu");

    if (!isHomePage) {
      parentElement.classList.add("is-active");
    }
    const header = megaMenu.closest(".header");

    function handleMouseLeave(event) {
      const targetSubMenu = categoryPanel.querySelector(
        ".full-mega-menu--panel--level .is-expanded"
      );

      if (
        Array.from(primaryNavItems).some((item) => item.classList.contains("is-active"))
      )
        document.body.classList.remove("open-cc");

      !header.classList.contains("is-sticky") &&
        isHomePage &&
        parentElement.classList.remove("is-active");

      primaryNavItems.forEach((el) => el.classList.remove("is-active"));
      if (targetSubMenu && !parentElement.contains(event.relatedTarget)) {
        targetSubMenu.classList.remove("is-expanded");
        targetSubMenu.classList.add("is-closing");
        categoryPanel.style.opacity = "0";
        targetSubMenu.classList.remove("is-closing");
        categoryPanel.style.display = "none";
      }
    }

    // Add the mouseleave event listener to the parent element
    parentElement.addEventListener("mouseleave", handleMouseLeave);

    for (let i = 0; i < primaryNavItems.length; i++) {
      primaryNavItems[i].addEventListener("mouseover", function () {
        parentElement.classList.add("is-active");
        primaryNavItems.forEach(
          (el) => primaryNavItems[i] !== el && el.classList.remove("is-active")
        );
        document.body.classList.add("open-cc");

        primaryNavItems[i].classList.add("is-active");
        const anchorElement = primaryNavItems[i].querySelector("a");
        const dataTarget = anchorElement.getAttribute("data-target");
        const targetSubMenu = categoryPanel.querySelector(
          `.full-mega-menu--panel--level ${dataTarget}`
        );

        // If the nav item does not render a megamenu panel
        if (targetSubMenu != null && targetSubMenu.classList.contains("is-expanded")) {
          return; // Do nothing if already expanded
        }

        // If another menu is currently being expanded, ignore this event
        if (isExpanding) {
          return;
        }

        isExpanding = true; // Set flag to true while expanding menu
        removeExpandedClass().then((result) => {
          if (targetSubMenu == null) {
            isExpanding = false; // Reset flag if no submenu found
            return;
          }
          categoryPanel.style.display = "flex";
          setTimeout(() => {
            categoryPanel.style.opacity = "1";
          }, 0);

          targetSubMenu.style.opacity = "0"; // Initially set child text opacity to 0
          setTimeout(() => {
            targetSubMenu.style.transition = "opacity 0.2s ease-in-out"; // Apply transition to child text
            targetSubMenu.style.opacity = "1"; // Fade in child text
          }, 100);

          if (!targetSubMenu.classList.contains("is-closing")) {
            targetSubMenu.classList.add("is-expanded");
          }

          // Reset flag after expansion is complete
          isExpanding = false;
        });
      });
    }
  });
});
